import { IC_APPLICATION_NAME } from './constants';

const getLoginUrl = (continueUrl?: string) => {
    const continueQuery = continueUrl
        ? `?continue=${encodeURIComponent(continueUrl)}`
        : '';

    const separator = continueQuery ? '&' : '?';
    return `${window.ID_AUTH_URL}/login${continueQuery}${separator}application=${IC_APPLICATION_NAME}`;
};

const getLogoutUrl = () => {
    const continueQuery = `?continue=${encodeURIComponent(
        window.SAC_BASE_URL
    )}`;

    return `${window.LOGOUT_URL}${continueQuery}&application=${IC_APPLICATION_NAME}`;
};

export { getLoginUrl, getLogoutUrl };
